"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const React = require("react");
const react_native_1 = require("react-native");
class Modal extends React.Component {
    render() {
        const { children, visible, overlayStyle, onRequestClose } = this.props;
        return (React.createElement(react_native_1.Modal, { animationType: "fade", transparent: true, visible: visible, supportedOrientations: ['landscape', 'portrait'], onRequestClose: onRequestClose },
            React.createElement(react_native_1.TouchableWithoutFeedback, { onPress: onRequestClose },
                React.createElement(react_native_1.View, { style: [styles.overlay, overlayStyle] }, children))));
    }
}
exports.Modal = Modal;
const styles = react_native_1.StyleSheet.create({
    overlay: {
        flex: 1,
        backgroundColor: 'rgba(33, 33, 33, 0.7)'
    }
});
